import React from 'react';
import { Button, Row, Col } from 'antd';
import {
  SDrawerOrModal,
} from 'shj-components'
import dayjs from 'dayjs';
import styles from './index.module.less'

export default function CustomerDetail ({
  customerInfo = {},
  open = false,
  onClose = () => {}
})  {

  return (
    <div className={styles.customerDetail}>
      <SDrawerOrModal
        open={open}
        onCancel={onClose}
        width="30%"
        title={"查看客户信息"}
        antdProps={{
          footer: <div style={{ textAlign: 'right' }}>
            <Button style={{ marginRight: '10px' }} onClick={onClose}>
              取消
            </Button>
          </div>
        }}
      >
        <div>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>客户姓名：</span>
              <span className={styles.content}>{ (customerInfo as any)?.customerInfo?.name }</span>
            </Col>
          </Row>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>客户电话：</span>
              <span className={styles.content}>{ (customerInfo as any)?.customerInfo?.phone }</span>
            </Col>
          </Row>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>性别：</span>
              <span className={styles.content}>{ (customerInfo as any)?.customerInfo?.gender }</span>
            </Col>
          </Row>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>年龄：</span>
              <span className={styles.content}>{ (customerInfo as any)?.customerInfo?.age }</span>
            </Col>
          </Row>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>生日：</span>
              <span className={styles.content}>{ dayjs((customerInfo as any)?.customerInfo?.birthday).format('YYYY-MM-DD') }</span>
            </Col>
          </Row>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>职业：</span>
              <span className={styles.content}>{ (customerInfo as any)?.customerInfo?.careerName }</span>
            </Col>
          </Row>
          <Row gutter={[15, 10]} className={styles.rowBox}>
            <Col span={24} className={styles.colBox}>
              <span className={styles.titleBox}>邮箱：</span>
              <span className={styles.content}>{ (customerInfo as any)?.customerInfo?.email }</span>
            </Col>
          </Row>
          {
            (customerInfo as any)?.memberInfo && (
              <>
                <div className={styles.allTitleBox}>
                  <div className={styles.titleFont}>会员信息</div>
                </div>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>会员ID：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.id }</span>
                  </Col>
                </Row>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>会员昵称：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.name }</span>
                  </Col>
                </Row>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>会员积分：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.integralValue }</span>
                  </Col>
                </Row>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>会员等级：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.levelName }</span>
                  </Col>
                </Row>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>最近访问时间：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.lastLoginTime }</span>
                  </Col>
                </Row>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>会员成长值：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.growValue }</span>
                  </Col>
                </Row>
                <Row gutter={[15, 10]} className={styles.rowBox}>
                  <Col span={24} className={styles.colBox}>
                    <span className={styles.titleBox}>入会时间：</span>
                    <span className={styles.content}>{ (customerInfo as any)?.memberInfo?.createdTime }</span>
                  </Col>
                </Row>
              </>
            )
          }
        </div>
      </SDrawerOrModal>
    </div>
  )
}